import axios from 'axios'
import { evowalkActionQuery } from './evowalkDevice'
console.log(axios)

/** Error for a failed start. Keeps a trial id when the recorder already created the row. */
function startError(message, data) {
    const err = new Error(message);
    if (data && typeof data === 'object') {
        const raw = data.id != null && data.id !== '' ? data.id : data.trial_id;
        if (raw != null && raw !== '') err.trialId = String(raw);
    }
    return err;
}

// Start a recording on the RPi. For calibration assessments, you can optionally
// pass a fifth argument `options` with `{ redo: true, trialId: <existing_id> }`
// so the backend can branch into a restart-calibration flow.
export async function startRecording(patientID, res, assessment, calibrationID, options = {}) {
    const token = localStorage.getItem("token");
    console.log('started recording')
    
    // Check if EvoWalk Integration is enabled in Account settings
    const evowalkIntegrationEnabled = localStorage.getItem('evowalkIntegrationEnabled') === 'true';
    console.log('EvoWalk Integration Enabled (start):', evowalkIntegrationEnabled);
    
    var url = "";
    if(assessment.substr(0, 5) == "calib") {
      url = `/api/start-record?patient_id=${patientID}&res=${res}&assessment="${assessment}"&length=${localStorage.getItem('checkerboardLength')}&width=${localStorage.getItem('checkerboardWidth')}`;
      // When called from the Redo button, we pass a hint to the backend so it
      // can reuse an existing calibration id instead of creating a new one.
      if (options.redo && options.trialId) {
        url += `&redo=1&trial_id=${encodeURIComponent(options.trialId)}`;
      }
    } else {
      url = `/api/start-record?patient_id=${patientID}&res=${res}&assessment="${assessment}"`;
      // Always send the key: older RPi builds reject the request when the param is
      // missing entirely. Pipeline 2.0 has no calibration to pick, so send empty.
      url += `&calibration_id=${calibrationID != null ? encodeURIComponent(calibrationID) : ''}`;
    }
    
    // Add parameter to skip EvoWalk connection if integration is disabled
    if (!evowalkIntegrationEnabled) {
      url += `&skip_evowalk=true`;
      console.log('EvoWalk integration disabled - adding skip_evowalk=true');
    } else {
      console.log('EvoWalk integration enabled - will connect to EvoWalk devices');
    }
    
    console.log('Start recording URL:', url);

    return fetch(window.RECORDING_URL + url,{
      headers:{
        Authorization:'Bearer '+token
      }
    } )
      .then(async (res) => {
        let data = null;
        try {
          data = await res.json();
        } catch (parseErr) {
          if (!res.ok) {
            throw new Error(`Failed to start recording (HTTP ${res.status})`);
          }
          throw parseErr;
        }
        if (!res.ok) {
          throw startError(
            (data && (data.error || data.reason || data.message)) ||
              `Failed to start recording (HTTP ${res.status})`,
            data
          );
        }
        // Mock / RPi may return 200 with an error payload when cameras fail to init.
        if (data && typeof data === 'object') {
          if (data.error) {
            throw startError(data.error, data);
          }
          // app.py uses { status: 'failure', reason: '...' } (not HTTP 4xx).
          if (data.status === 'failure' || data.status === 'error') {
            throw startError(data.reason || data.message || 'Failed to start recording', data);
          }
        }
        return data;
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

export async function stopRecording() {
    const token = localStorage.getItem("token");
    
    // Check if EvoWalk Integration is enabled in Account settings
    const evowalkIntegrationEnabled = localStorage.getItem('evowalkIntegrationEnabled') === 'true';
    console.log('EvoWalk Integration Enabled (stop):', evowalkIntegrationEnabled);
    
    let url = `/api/stop-record`;
    
    // Add parameter to skip EvoWalk connection if integration is disabled
    if (!evowalkIntegrationEnabled) {
      url += `?skip_evowalk=true`;
      console.log('EvoWalk integration disabled - adding skip_evowalk=true');
    } else {
      console.log('EvoWalk integration enabled - will disconnect from EvoWalk devices');
    }
    
    console.log('Stop recording URL:', url);
    
    return fetch(window.RECORDING_URL + url,{
      headers:{
        Authorization:'Bearer '+token
      }
    })
           .then(res => {
             console.log(res);
             return res.json();
           })
           .catch(err => {
             console.log(err);
             throw err;
           })
}

export async function pauseRecording() {
    const token = localStorage.getItem("token");
    return fetch(window.SERVER_URL + '/api/pause-record',{
      headers:{
        Authorization:'Bearer '+token
      }
    })
           .then(res => console.log(res))
           .catch(err => console.log(err)) 
}

export async function resumeRecording() {
    const token = localStorage.getItem("token");
    return fetch(window.SERVER_URL + '/api/resume-record',{
      headers:{
        Authorization:'Bearer '+token
      }
    })
           .then(res => console.log(res))
           .catch(err => console.log(err)) 
}

export async function clearRecording() {
    const token = localStorage.getItem("token");
    const url = window.RECORDING_URL + '/api/clear-record';
    return fetch(url, {
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(res => (res.ok ? res.json() : res.text().then(t => { throw new Error(t || res.status); })))
      .catch(err => { console.error("[clearRecording] clear-record error:", err); throw err; })
}

export async function checkDevice() {
  const token = localStorage.getItem("token");
  
  // Check if EvoWalk Integration is enabled in Account settings
  const evowalkIntegrationEnabled = localStorage.getItem('evowalkIntegrationEnabled') === 'true';
  console.log('EvoWalk Integration Enabled (checkDevice):', evowalkIntegrationEnabled);
  
  let targ = '';
  
  // Add parameter to skip EvoWalk connection if integration is disabled
  if (!evowalkIntegrationEnabled) {
    targ = `?skip_evowalk=true`;
    console.log('EvoWalk integration disabled - adding skip_evowalk=true to checkDevice');
  } else {
    console.log('EvoWalk integration enabled - will check EvoWalk devices');
  }
  
  console.log('Check device URL:', window.RECORDING_URL + "/check" + targ);
  
  return fetch(window.RECORDING_URL + "/check" + targ,{
    headers:{
      Authorization:'Bearer '+ token
    }
  })
         .then(res => res.json())
         .catch(err => console.log(err))
}

// export async function getTrialType() {
//     return fetch('/api/get-trial-type')
//            .then(res => res.json())
//            .catch(err => console.log(err))
// }

export async function getCalibrationVideos() {
  const token = localStorage.getItem("token");
  return fetch(window.SERVER_URL + '/a/get-calibration-list',{
    headers:{
      Authorization:'Bearer '+token
    }
  })
         .then(res => res.json())
         .catch(err => console.log(err))
}

export async function getCalibrationStatus(id) {
  const token = localStorage.getItem("token");
  const url = `${window.SERVER_URL}/a/get-calibration-status?id=${encodeURIComponent(id)}`;
  return fetch(url, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  })
    .then(res => {
      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }
      return res.json();
    })
    .catch(err => {
      console.error("Error fetching calibration status:", err);
      throw err;
    });
}

export async function getCountVideos(calib_id) {
  const token = localStorage.getItem("token");
  return fetch(`${window.SERVER_URL}/a/count-videos?calib_id=${calib_id}`, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  })
  .then(res => res.json())
  .then(data => data.video_count)
  .catch(err => console.error("Error fetching video count:", err));
}


export function getCalibrationVideoUrl(id){
  const token = localStorage.getItem("token");
  return axios.get(window.SERVER_URL + '/a/get-calibration-video-url?id='+id ,{
    headers:{
      Authorization:'Bearer '+token
    }
  }).then(res=>res.data)
}

export async function deleteCalibration(id) {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.delete(window.SERVER_URL + '/a/delete-calibration?id=' + id, {
      headers: {
        Authorization: 'Bearer ' + token
      }
    });
    return response.data;
  } catch (err) {
    console.error("Error deleting calibration:", err);
    throw err;
  }
}

/** Move a single calibration to trash (soft delete; purged after 30 days). */
export async function trashCalibration(id) {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.post(
      window.SERVER_URL + '/a/trash-calibration',
      { id },
      { headers: { Authorization: 'Bearer ' + token, 'Content-Type': 'application/json' } }
    );
    return response.data;
  } catch (err) {
    console.error("Error trashing calibration:", err);
    throw err;
  }
}

/** Move multiple calibrations to trash. Falls back to hard delete if backend does not have trash endpoint (404). */
export async function trashCalibrations(ids) {
  const idList = Array.isArray(ids) ? ids : [];
  if (idList.length === 0) return { ok: true, trashed: 0 };
  try {
    const response = await axios.post(
      window.SERVER_URL + '/a/trash-calibrations',
      { ids: idList },
      { headers: { Authorization: 'Bearer ' + localStorage.getItem("token"), 'Content-Type': 'application/json' } }
    );
    return response.data;
  } catch (err) {
    if (err?.response?.status === 404) {
      for (const id of idList) {
        try {
          await deleteCalibration(id);
        } catch (e) {
          console.error("Error deleting calibration:", id, e);
        }
      }
      return { ok: true, trashed: idList.length };
    }
    console.error("Error trashing calibrations:", err);
    throw err;
  }
}

export function getRecordingVideoUrl(id){
  const token = localStorage.getItem("token");
  return axios.get(window.SERVER_URL + '/a/get-recording-video-url?id='+id ,{
    headers:{
      Authorization:'Bearer '+token
    }
  }).then(res=>res.data)
}
// export async function getTrialTypeDetails(trialType) {
//     return fetch(`/api/get-trial-type-details?trial_type=${trialType}`)
//            .then(res => res.json())
//            .catch(err => console.log(err))
// }

export function saveNotes(trialID, notes) {
    const token = localStorage.getItem("token");
    return fetch(window.SERVER_URL + `/api/save-record?trial_id=${trialID}&notes=${notes}`,{
      headers:{
        Authorization:'Bearer '+token
      }
    })
           .then(res => console.log(res))
           .catch(err => console.log())
}

// export async function submitDimensions(length, width) {
//     return fetch(`/api/submit-dimensions?length=${length}&width=${width}`)
//       .then(res => res.json())
//       .catch(err => console.log(err))
//   }

export function listGopros() {
  const token = localStorage.getItem("token");
  return fetch(window.RECORDING_URL + "/api/list-gopros", {
    headers: {
      Authorization: 'Bearer ' + token
    }
  })
  .then(res => {
    if (!res.ok) { // Check if the response status is not in the 2xx range
      throw new Error(`HTTP error! status: ${res.status}`); // Throw an error to be caught in the catch block
    }
    return res.json(); // Return the response as JSON if the status is OK
  });
}

// export function connectGopro(mac) {
//   const token = localStorage.getItem("token");
//   return fetch(window.RECORDING_URL + `/api/connect-gopro?mac=${mac}`,{
//     headers:{
//       Authorization:'Bearer '+token
//     }
//   })
//          .then(res => res.json())
// }

// export function removeGopro(mac) {
//   const token = localStorage.getItem("token");
//   return fetch(window.RECORDING_URL + `/api/remove-gopro?mac=${mac}`,{
//     headers:{
//       Authorization:'Bearer '+token
//     }
//   })
//          .then(res => res.json())
// }

export function connectGopro(name) {
  const token = localStorage.getItem("token");
  return fetch(window.RECORDING_URL + `/api/connect-gopro?name=${name}`,{
    headers:{
      Authorization:'Bearer '+token
    }
  })
         .then(res => res.json())
}

export function removeGopro(name) {
  const token = localStorage.getItem("token");
  return fetch(window.RECORDING_URL + `/api/remove-gopro?name=${name}`,{
    headers:{
      Authorization:'Bearer '+token
    }
  })
         .then(res => res.json())
}

export function wakeGopro(name) {
  const token = localStorage.getItem("token");
  return fetch(window.RECORDING_URL + `/api/wake-gopro?name=${name}`, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  })
         .then(res => res.json())
}

export function sleepGopro(name) {
  const token = localStorage.getItem("token");
  return fetch(window.RECORDING_URL + `/api/sleep-gopro?name=${name}`, {
    headers: {
      Authorization: 'Bearer ' + token
    }
  })
         .then(res => res.json())
}

// EvoWalk API functions
export function listEvowalks() {
  const token = localStorage.getItem("token");
  return fetch(window.RECORDING_URL + "/api/list-evowalk", {
    headers: {
      Authorization: 'Bearer ' + token
    }
  })
  .then(res => {
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    return res.json();
  });
}

function evowalkCommand(path, name, address) {
  const token = localStorage.getItem("token");
  return fetch(window.RECORDING_URL + path + '?' + evowalkActionQuery(name, address), {
    headers:{
      Authorization:'Bearer '+token
    }
  })
         .then(res => res.json())
}

export function connectEvowalk(name, address) {
  return evowalkCommand('/api/connect-evowalk', name, address);
}

export function disconnectEvowalk(name, address) {
  return evowalkCommand('/api/disconnect-evowalk', name, address);
}

export function removeEvowalk(name, address) {
  return evowalkCommand('/api/remove-evowalk', name, address);
}

export function evowalkStatus() {
  const token = localStorage.getItem("token");
  return fetch(window.RECORDING_URL + "/api/evowalk-status", {
    headers: {
      Authorization: 'Bearer ' + token
    }
  })
  .then(res => {
    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }
    return res.json();
  });
}

export function checkRpiConnection() {
  // Send a generic Flask HTTP request to check if the server is responding
  // Use GET request to root endpoint to verify Flask server is up
  // Set a 3-second timeout to detect disconnection quickly
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 3000); // 3 second timeout
  
  return fetch(window.RECORDING_URL + "/", {
    method: 'GET',
    mode: 'cors',
    signal: controller.signal
  })
  .then(res => {
    clearTimeout(timeoutId);
    // Any response (even 404 or 500) means Flask server is up and responding
    // 200-299: Success, server is up
    // 300-399: Redirects, server is up
    // 400-499: Client errors, but server is responding
    // 500-599: Server errors, but server is responding
    if (res.status >= 200 && res.status < 600) {
      return {
        status: 'success',
        connected: true,
        message: 'RPi connection is active'
      };
    } else {
      return {
        status: 'success',
        connected: false,
        message: `RPi connection failed: HTTP ${res.status}`
      };
    }
  })
  .catch(err => {
    clearTimeout(timeoutId);
    // Network errors, timeouts, CORS issues, etc. mean server is not reachable
    console.error("Error checking RPi connection:", err);
    return {
      status: 'success',
      connected: false,
      message: err.message || 'RPi connection timeout or network error'
    };
  });
}
